<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <!--评分任务编号-->
              <el-col :span="6">
                <el-form-item :label="$t('spm.trak')" prop="serialNo">
                  <el-input v-model.trim="queryCondition.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!--SSR编号 "typeS": "SSR", -->
              <el-col :span="6">
                <el-form-item :label="$t('spm.ssrNo')" prop="ssrNo">
                  <el-input v-model.trim="queryCondition.ssrNo" clearable @clear="clearSsrNo" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!--RFP编号 "typeR": "RFP", -->
              <el-col :span="6">
                <el-form-item :label="$t('spm.rfpNo')" prop="rfpNo">
                  <el-input v-model.trim="queryCondition.rfpNo" clearable @clear="clearRfpNo" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!-- Category1 -->
              <el-col :span="6">
                <el-form-item label="Category1" prop="category1Id">
                  <el-select v-model="queryCondition.category1Id" clearable @change="changeCategory1()" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <!--Category2-->
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2Id">
                    <el-select v-model="queryCondition.category2Id" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--状态-->
                <el-col :span="6">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <template v-if="emplFlag == 'SS'">
                      <ic-select clearable table="TT_SUPPLIER_MARK" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                    </template>
                    <template v-if="emplFlag != 'SS'">
                      <ic-select clearable table="TT_SUPPLIER_MARK_SUPPLIER" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                    </template>
                  </el-form-item>
                </el-col>
                <!-- 创建日期 -->
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="startDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.startDate" type="date" :picker-options="pickerOptionsStart" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="endDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.endDate" type="date" :picker-options="pickerOptionsEnd" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <!--供应商编号/邀请码-->
                <el-col :span="6">
                  <el-form-item :label="$t('spm.invitationCode')" prop="supplierCode">
                    <el-input type="textarea" :rows="2" :placeholder="$t('spm.NoPlaceHolder')" v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <!--供应商简称-->
                <el-col :span="6">
                  <el-form-item :label="$t('spm.supplierNameShort')" prop="supplierNameShort">
                    <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div v-if="emplFlag != 'SUP'" class="action-btn-row">
      <el-button size="mini" class="btn" v-acl="SaveCreateMark" @click="newBuilt" type="primary">{{$t('common.newBuilt')}}</el-button>
      <el-button size="mini" class="btn" v-acl="DeleteMark" @click="deleteRow" type="danger">{{$t('common.del')}}</el-button>
      <el-button size="mini" class="btn" v-acl="SaveCreateMark" @click="revokeRow" type="danger">{{$t('common.return')}}</el-button>
      <el-button size="mini" class="btn" @click="download" type="primary">{{$t('common.download')}}</el-button>
      <!--<el-button @click="newBuilt" type="primary">发布</el-button>-->
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column fixed sortable type="selection" width="55" align="center"></el-table-column>
      <!--评分任务编号-->
      <el-table-column show-overflow-tooltip prop="serialNo" :label="$t('spm.trak')">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{scope.row.serialNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="ssrNo" :label="$t('spm.ssrNo')">
        <template slot-scope="scope">
          {{scope.row.type=='SSR'?scope.row.ssrNo:''}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="no" :label="$t('spm.rfpNo')">
        <template slot-scope="scope">
          {{scope.row.type=='SSR'?'':scope.row.ssrNo}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="currentRound" :label="$t('spm.ssrcurrentRound')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="catagory1Name" label="Category1"></el-table-column>
      <el-table-column show-overflow-tooltip prop="category2Name" label="Category2"></el-table-column>
      <!-- <el-table-column prop="supplierCode" :label="$t('spm.supplierCode')"></el-table-column> -->
      <el-table-column show-overflow-tooltip prop="supplierNameShort" :label="$t('spm.supplierNameShort')"></el-table-column>
      <el-table-column show-overflow-tooltip v-if="emplFlag != 'SUP'" prop="totalScore" :label="$t('spm.totalScore')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="statusI18n" :label="$t('spm.statusI18n')"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "@/api/spm/spm-manage";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
export default {
  components: { IcSelect },
  name: "spm-manage",
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      dataArr: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        ssrNo: null,
        rfpNo: '',
        category1Id: null,
        category2Id: null,
        status: null,
        startDate: null,
        endDate: null,
        supplierCode: null,
        supplierNameShort: null,
        typeS: '',
        typeR: '',
      },
      tableList: [],
      emplFlag: '',
      categoryList1: [],
      categoryList2: [],
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.getInputChoiceValues()
    this.queryData(1);
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      this.emplFlag = 'SS';
    }
    this.getCategoryList(1)
  },
  methods: {
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (commonFun.isNotEmpty(that.queryCondition.ssrNo)) {
        this.queryCondition.typeS = "SSR"
      }
      if (commonFun.isNotEmpty(that.queryCondition.rfpNo)) {
        this.queryCondition.typeR = "RFP"
      }
      apiService.search(this.queryCondition).then(res => {
        this.tableList = res.data.resultData;
        this.totalCount = res.data.totalCount;
      });
    },
    clearSsrNo() {
      this.queryCondition.typeS = ""
    },
    clearRfpNo() {
      this.queryCondition.typeR = ""
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.category2Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.category1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    //新增
    newBuilt() {
      this.$router.push({
        name: 'spm-manage-add'
        , query: { id: null }
      });
    },
    //去往评分详情
    toDetail(row) {
      //新建状态去新建页面
      if (row.status == 'DRAFT') {
        this.$router.push({
          name: 'spm-manage-add'
          , query: { id: row.ttSupplierMarkId }
        });
      } else {
        this.$router.push({
          name: 'spm-manage-detail'
          , query: { id: row.ttSupplierMarkId }
        });
      }
    },
    deleteRow() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        that.$message({
          message: that.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        let ids = rows.map(data => data.ttSupplierMarkId)
        let existsNotDraftRow = rows.some(row => row.status != 'DRAFT')
        // 请确认是否删除!
        this.$confirm(existsNotDraftRow ? "请确认是否删除评分任务整张单据，包含所有供应商。" : this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          apiService.deleteByIds(ids).then(res => {
            if (res.code === '200') {
              that.$message({
                message: this.$t("common.delSuccess"),
                type: "success"
              });
              that.queryData(1);
              this.$refs.tableList.clearSelection()
            } else {
              Message({ message: res.meta.msg, type: "error" });
              this.queryData();
            }
          });
        }).catch(() => {

        });
      }
    },
    revokeRow() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        that.$message({
          message: that.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        let ids = rows.map(data => data.ttSupplierMarkSupplierId)
        let existsNotDraftRow = rows.some(row => row.status != 'DRAFT')
        // 请确认是否删除!
        this.prompt("请填写原因", null, null, null, {
          inputValidator: (val) => {
            if (commonFun.isEmpty(val)) {
              return that.$t("common.canNotBeEmpty")
            }
            return val.length < 301
          },
          inputErrorMessage: that.$t("sensory.report.reasonTooLong")
        }).then((res) => {
          apiService.revoke(ids, res.value).then(res => {
            if (res.code === '200') {
              that.$message({
                message: this.$t("common.delSuccess"),
                type: "success"
              });
              that.queryData(1);
              this.$refs.tableList.clearSelection()
            } else {
              Message({ message: res.meta.msg, type: "error" });
              this.queryData();
            }
          });
        }).catch(() => {

        });
      }
    },
    download() {
      apiService.download(this.queryCondition).then(res => {

      });
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        ssrNo: null,
        rfpNo: '',
        category1Id: null,
        category2Id: null,
        status: null,
        startDate: null,
        endDate: null,
        supplierCode: null,
        supplierNameShort: null,
        typeS: '',
        typeR: '',
      }
      this.queryData();
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_SUPPLIER_MARK:STATUS"] = "TT_SUPPLIER_MARK:STATUS";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        console.log(res["TT_SUPPLIER_MARK:STATUS"])
      });
    },

  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.el-select {
  width: 100%;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
